import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import ScrollToTop from "./components/ScrollTop";
import { Helmet } from "react-helmet";
import Success from "./templates/Success";
import Error from "./templates/Error";
import Unsub from "./templates/Unsub";
import BabbelSuccess from "./templates/BabbelSuccess";
import BabbelUnsub from "./templates/BabbelUnsub";

function App() {
  const domainElms = window.location.host.split(".");
  const domain = window.location.host.replace(
    domainElms.length > 2 ? domainElms[0] + "." : "",
    ""
  );
  const title = domain[0].toUpperCase() + domain.substring(1);

  return (
    <div className={"App"}>
      <BrowserRouter>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{title}</title>
          <meta property="og:title" content={title} />
          <meta
            property="og:description"
            content="Digital Services Reimagined"
          />
          <meta property="og:image:secure_url" content="" />
          <meta property="og:url" content={window.location.href} />
          <meta name="description" content="Digital Services Reimagined" />
          <meta property="og:type" content="website" />
          <meta name="author" content="Noju" />
        </Helmet>
        <ScrollToTop>
          <Routes>
            <Route path={"/error"} element={<Error />} key={"Error"} />
            <Route path={"/nord-vpn"} element={<Success />} key={"ThankYou"} />
            <Route path={"/nord-vpn/unsub"} element={<Unsub />} key={"Unsub"} />
            <Route path={"/babbel"} element={<BabbelSuccess />} key={"BabbelThankYou"} />
            <Route path={"/babbel/unsub"} element={<BabbelUnsub />} key={"BabbelUnsub"} />
          </Routes>
        </ScrollToTop>
      </BrowserRouter>
    </div>
  );
}

export default App;
